const C = require("../constants");
const initial_data = {open: false, ingredient:{id:null, name:'',}};

function IngredientDialogReducer(state = initial_data, action) {
    switch (action.type) {
        case C.INGREDIENT_DIALOG:
            return action.data;
        default:
            return state;
    }
}

export default IngredientDialogReducer;


// WEBPACK FOOTER //
// ./src/reducers/IngredientDialogReducer.js